import React from 'react';
import { ArrowRight } from 'lucide-react';
export function BuySell() {
  return <section className="py-20 md:py-32 bg-brand-cream" data-id="element-1">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-6 md:gap-10" data-id="element-3">
          {/* Buying Card */}
          <div className="group relative bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 flex flex-col h-full border border-brand-taupe/10" data-id="element-4">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-copper scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left z-10" data-id="element-5"></div>
            <div className="h-64 md:h-80 overflow-hidden relative" data-id="element-6">
              <img src="https://cdn.magicpatterns.com/uploads/11W7ogoaGTcbcr3rY3JZBN/aspen-metzger-K39ncY0WmDY-unsplash.jpg" alt="Buying a home" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-7" />
            </div>
            <div className="p-8 md:p-12 flex flex-col flex-grow" data-id="element-8">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-9">
                Buying a Home
              </h2>
              <p className="text-brand-taupe mb-8 flex-grow text-lg leading-relaxed" data-id="element-10">
                Discover your perfect space in the Front Range. We provide
                high-touch guidance to help you navigate the market and find a
                home that fits your lifestyle.
              </p>
              <button className="bg-brand-copper hover:bg-brand-copper/90 text-white px-8 py-4 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 w-full md:w-auto self-start" data-id="element-11">
                Start Your Search
                <ArrowRight size={18} data-id="element-12" />
              </button>
            </div>
          </div>

          {/* Selling Card */}
          <div className="group relative bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 flex flex-col h-full border border-brand-taupe/10" data-id="element-13">
            <div className="absolute top-0 left-0 w-full h-1 bg-brand-copper scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left z-10" data-id="element-14"></div>
            <div className="h-64 md:h-80 overflow-hidden relative" data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/7taDNB1nLJ7vx3UL1xbwK3/yaroslav-muzychenko-pAfmRJrCF8Q-unsplash.jpg" alt="Selling your home" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-16" />
            </div>
            <div className="p-8 md:p-12 flex flex-col flex-grow" data-id="element-17">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-4" data-id="element-18">
                Selling Your Home
              </h2>
              <p className="text-brand-taupe mb-8 flex-grow text-lg leading-relaxed" data-id="element-19">
                Maximize your property's value with our editorial marketing
                approach and deep local expertise. We make the selling process
                seamless and rewarding.
              </p>
              <button className="bg-brand-copper hover:bg-brand-copper/90 text-white px-8 py-4 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 w-full md:w-auto self-start" data-id="element-20">
                What's My Home Worth?
                <ArrowRight size={18} data-id="element-21" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}